import React, { FC } from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export const IconMinus: FC<PropsWithClassProps<'iconMinus'>> = ({ classProps }) => {
  return (
    <svg
      className={classProps?.iconMinus}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="3" y1="8.5" x2="15" y2="8.5" stroke="black" />
    </svg>
  );
};
